(function($, w, undefined) {

    function NewsArticle(args) {
        this.defaults = {
            container: ''
        };

        this.options = $.extend(true, {}, this.defaults, args);

        this.$container = $(this.options.container);

        if (this.$container.length === 0) {
            return;
        }

        this.wrappedIframe();
    }

    NewsArticle.prototype.wrappedIframe = function () {
        if (!this.$container || this.$container === null) {
            return;
        }

        var $iframes = this.$container.find('iframe');
        $iframes.each(function () {
            $(this).wrap("<div class='iframe-wrapper'></div>");
        });
    };

    w.MCN = w.MCN || {};
    w.MCN.NewsArticle = NewsArticle;

})(jQuery, window);
